// see also collectionKeyword, collectionSeparator and collectionSetter in MCB.Sites.Mobile.Core\Services\AuctionProductListFilterService.cs

export const collectionIdKeyword = "collectionId";
export const collectionIdSetter = "=";
export const collectionIdSeparator = "-";
